export enum RedirectReason {
  COMPLETED_ONBOARDING = 'COMPLETED_ONBOARDING',
  EXITED_ONBOARDING = 'EXITED_ONBOARDING'
}

export enum OnboardingStep {
  NOT_STARTED = 'NOT_STARTED',
  INTRO = 'INTRO',
  VERBS = 'VERBS',
  NOUNS = 'NOUNS',
  COBENEFITS = 'CO-BENEFITS',
  SKILLS = 'SKILLS',
  LOCATION = 'LOCATION',
  NOTIFICATIONS = 'NOTIFICATIONS',
  MEMBERSHIP = 'MEMBERSHIP',
  VERIFICATION = 'VERIFICATION',
  COMPLETED = 'COMPLETED'
}

export enum OnboardingStepState {
  NOT_STARTED = 'NOT STARTED',
  STARTED = 'STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED'
}

export const OnboardingStepToUrl = {
  [OnboardingStep.NOT_STARTED]: '/onboarding/intro',
  [OnboardingStep.INTRO]: '/onboarding/intro',
  [OnboardingStep.VERBS]: '/onboarding/verbs',
  [OnboardingStep.NOUNS]: '/onboarding/nouns',
  [OnboardingStep.COBENEFITS]: '/onboarding/cobenefits',
  [OnboardingStep.SKILLS]: '/onboarding/skills',
  [OnboardingStep.LOCATION]: '/onboarding/location',
  [OnboardingStep.NOTIFICATIONS]: '/onboarding/notifications',
  [OnboardingStep.MEMBERSHIP]: '/onboarding/membership',
  [OnboardingStep.VERIFICATION]: '/onboarding/verification'
}

export enum TrialStatus {
  ELIGIBLE = 'ELIGIBLE',
  ONGOING = 'ONGOING',
  ENDING_SOON = 'ENDING_SOON',
  ENDING_TODAY = 'ENDING_TODAY',
  COMPLETED = 'COMPLETED'
}
